import script from "./NewsEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsEdit.vue?vue&type=script&setup=true&lang=js"

import "./NewsEdit.vue?vue&type=style&index=0&id=f3dabf3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3dabf3c"]])

export default __exports__